<template>
  <v-container>
    <v-row>
      <v-col lg="5" md="12">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title class="font-weight-bold justify-center mb-5">
            Información de evaluaciones de desempeño
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-calendar</v-icon>
                <span class="font-weight-bold">Fecha evaluación de desempeño académico:</span>
                <span class="ml-2">
                  {{ latestEvaluacionAcademicaDate ? formatFecha(latestEvaluacionAcademicaDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold">Calificación evaluación de desempeño académico:</span>
                <span class="ml-2">{{ latestEvaluacionAcademicaCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
            <v-divider class="my-4 mx-0"></v-divider>
            <v-row>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-calendar-check</v-icon>
                <span class="font-weight-bold">Fecha evaluación de desempeño:</span>
                <span class="ml-2">
                  {{ latestEvaluacionDesempenioDate ? formatFecha(latestEvaluacionDesempenioDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold">Calificación evaluación de desempeño:</span>
                <span class="ml-2">{{ latestEvaluacionDesempenioCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="7" md="12">
        <v-card class="card mx-2" color="primary">
          <v-card-title class="font-weight-bold justify-center">Asignación de CUP</v-card-title>
          <v-card-text>
            <v-text-field
              :value="getFullName(personal)"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Nombre del elemento"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              :value="personal ? personal.CUIP : ''"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="CUIP"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="cup"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="CUP"
              :rules="nameRules"
            >
              <template v-slot:label>Ingrese número de CUP <span class="red--text">*</span> </template>
            </v-text-field>
            <v-file-input
              v-model="file"
              rounded
              filled
              background-color="primary"
              color="secondary"
              dense
              accept=".pdf"
              :rules="nameRules"
            >
              <template v-slot:label>Adjuntar documento CUP <span class="red--text">*</span> </template>
            </v-file-input>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionEvaluacionC3"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de evaluaciones C3 <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaEvaluacionC3Calculada"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  label="Vigencia de evaluaciones C3"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionFormacionInicial"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de formación inicial <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaFormacionInicialCalculada"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  label="Vigencia de formación inicial"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionCompetenciasBasicas"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de competencias básicas <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaCompetenciasBasicasCalculada"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  label="Vigencia de competencias básicas"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionCup"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="dateRules"
                >
                  <template v-slot:label>Fecha de emisión de CUP <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaCupCalculada"
                  v-mask="'##/##/####'"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  label="Vigencia de CUP"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn v-bind="secondaryButtonProps" to="/desarrollo_profesional/personal">Cancelar</v-btn>
            <v-btn v-bind="primaryButtonProps" v-on:click="asignaCup()" :loading="loading" :disabled="loading">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { primaryButtonProps, secondaryButtonProps } from '../../components/props/props'

export default {
  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      primaryButtonProps,
      secondaryButtonProps,
      loading: false,
      cup: '',
      file: null,
      // Se inicializan con valores del personal (fechas de emisión)
      fechaEmisionEvaluacionC3: this.personal ? this.personal.vigenciaEvaluacionC3 : '',
      fechaEmisionFormacionInicial: this.personal ? this.personal.vigenciaFormacionInicial : '',
      fechaEmisionCompetenciasBasicas: this.personal ? this.personal.vigenciaCompetenciasBasicas : '',
      fechaEmisionCup: this.personal ? this.personal.vigenciaCup : '',
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, 'DD/MM/YYYY')
          return moment(date, 'DD/MM/YYYY').isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('respetoPrincipios', {
      latestEvaluacionDesempenioDate: 'getLatestEvaluacionDesempenioDate',
      latestEvaluacionDesempenioCalificacion: 'getLatestEvaluacionDesempenioCalificacion',
    }),
    ...mapGetters('respetoPrincipiosValores', {
      latestEvaluacionAcademicaDate: 'getLatestEvaluacionAcademicaDate',
      latestEvaluacionAcademicaCalificacion: 'getLatestEvaluacionAcademicaCalificacion',
    }),
    vigenciaEvaluacionC3Calculada() {
      if (!this.fechaEmisionEvaluacionC3) return ''
      const fecha = moment(this.fechaEmisionEvaluacionC3, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaFormacionInicialCalculada() {
      if (!this.fechaEmisionFormacionInicial) return ''
      const fecha = moment(this.fechaEmisionFormacionInicial, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaCompetenciasBasicasCalculada() {
      if (!this.fechaEmisionCompetenciasBasicas) return ''
      const fecha = moment(this.fechaEmisionCompetenciasBasicas, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaCupCalculada() {
      if (!this.fechaEmisionCup) return ''
      const fecha = moment(this.fechaEmisionCup, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
  },

  async mounted() {
    if (this.personal && this.personal.idPersonal) {
      await this.fetchRespetoPrincipios(this.personal.idPersonal)
      await this.fetchRespetoPrincipiosValores(this.personal.idPersonal)
    }
  },

  methods: {
    ...mapActions('personal', ['updateCupPersonal', 'fetchPersonal', 'updatePersonal', 'uploadCup']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('respetoPrincipiosValores', ['fetchRespetoPrincipiosValores']),
    ...mapActions('cups', ['createCup']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    asignaCup: async function () {
      this.loading = true
      try {
        this.personal.cup = this.cup
        await this.updateCupPersonal(this.personal)

        var formData = new FormData()
        formData.append('file', this.file)
        formData.append('idPersonal', this.personal.idPersonal)
        await this.uploadCup(formData)

        // Guardamos fechas de emisión (no las vigencias)
        this.personal.vigenciaEvaluacionC3 = this.fechaEmisionEvaluacionC3
        this.personal.vigenciaFormacionInicial = this.fechaEmisionFormacionInicial
        this.personal.vigenciaCompetenciasBasicas = this.fechaEmisionCompetenciasBasicas
        this.personal.vigenciaCup = this.fechaEmisionCup

        await this.updatePersonal(this.personal)

        // Nueva lógica para registrar el CUP en el módulo correspondiente
        const cupFormData = new FormData()
        cupFormData.append('cup', this.cup)
        // Se envía la fecha de emisión de CUP al módulo
        cupFormData.append('vigenciaCup', moment(this.fechaEmisionCup, 'DD/MM/YYYY').format('DD/MM/YYYY HH:mm:ss a'))
        cupFormData.append('observaciones', '')
        cupFormData.append('fk_idPersonal', this.personal.idPersonal)
        if (this.file) {
          cupFormData.append('adjunto', this.file)
        }

        await this.createCup({ idPersonal: this.personal.idPersonal, payload: cupFormData })

        this.$router.push('/desarrollo_profesional/personal')
      } catch (error) {
        console.error('Ocurrió un error al registrar el CUP:', error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar el CUP.')
      } finally {
        this.loading = false
      }
    },
    getFullName(personal) {
      if (!personal) return ''
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre}`
    },
    formatFecha(fecha) {
      if (!fecha) return 'Sin registro'
      if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY')
      }
      return 'Sin registro'
    },
  },
}
</script>
